// LICENSE_CODE ZON
'use strict'; /*jslint ts:true*/

export const SUPPORT_EMAIL = 'security@hola.org';

export const SUPPORT_SUBJECT = 'Bug Report';

export const SUPPORT_TEMPLATE = [
    'Bug Description',
    '===============',
    'Overview:',
    '',
    'Proof Of Concept:',
    '',
    'Impact:',
    '',
    'Suggested Fix:',
    '',
].join('\r\n');

export interface i_support_report_opt {
    to?: string;
    subject?: string;
    body?: string;
}

// mailto has a practical URL length limit (~2000 chars in most clients)
const MAX_BODY = 1500;

export const build_support_link = (opt: i_support_report_opt = {})=>{
    const to = opt.to||SUPPORT_EMAIL;
    const subject = opt.subject||SUPPORT_SUBJECT;
    let body = opt.body||SUPPORT_TEMPLATE;
    if (body.length>MAX_BODY)
        body = body.slice(0, MAX_BODY)+'\r\n...[truncated]';
    return `mailto:${to}`
        +`?subject=${encodeURIComponent(subject)}`
        +`&body=${encodeURIComponent(body)}`;
};

export const open_support_report = (opt: i_support_report_opt = {})=>{
    window.location.href = build_support_link(opt);
};
